const useAuthInitialStates = () => {
  const sessionInitialState = {
    authToken: "",
    email: "",
    name: "",
    lastname: "",
    rol: "",
    country_id: [],
    loader: false,
    isKeycloakAuth: false,
    username: "",
    roles: [],
    permissions: [],
    permissionsLoaded: false, // Flag to track if permissions have been fetched
  };

  const mfaPendingInitialState = {
    email: "",
    password: "",
    timestamp: null,
  };

  return {
    sessionInitialState,
    mfaPendingInitialState,
  };
};

export default useAuthInitialStates;
